<mat-card style="background: #f2f4f8;">
    <mat-card-content>
        <div style="width: 100%; ">
            <markdown [src]="href"></markdown>
        </div>
    </mat-card-content>
</mat-card>